import React from 'react';
import { SVGProps } from './types';

function CommendaIcon(props: SVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="24"
      fill="none"
      viewBox="0 0 26 24"
      {...props}
    >
      <path
        fill="currentColor"
        fillOpacity="0.3"
        d="M10.162 24h15.134l-3.783-3.692H6.379L10.162 24z"
      />
      <path
        fill="currentColor"
        d="M10.162 9.23V24L6.38 20.308V5.538l3.783 3.693z"
      />
      <path
        fill="currentColor"
        d="M21.513 5.538H6.379l3.783 3.693h15.134l-3.783-3.693zM.704 0l3.783 3.692v9.231L.704 9.385V0z"
      />
      <path fill="currentColor" d="M.704 0l3.783 3.692h9.459L10.32 0H.704z" />
    </svg>
  );
}

export { CommendaIcon };
